import { Grid, Typography } from '@material-ui/core';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import QCXFormStepWizard from '../../../../../shared-components/form-step-wizard/QCXFormStepWizard';

import QCXSelectPortoAeroportoAutocomplete from '../../../../../shared-components/select-porto-aeroporto/QCXSelectPortoAeroportoAutocomplete';
import InputWithCleanButton from '../../../../../components/declaracao-importacao/inputWithCleanButton/InputWithCleanButton';
import QCXFinalAlternativeCurrencyField from '../../../../../shared-components/final-currency-field/QCXFinalAlternativeCurrencyField';
import QCXSelectMoedaAutocomplete from '../../../../../shared-components/final-select-moeda-field/QCXSelectMoedaAutocomplete';
import QCXFinalDatePickerField from '../../../../../shared-components/final-date-picker-field/QCXFinalDatePickerField';
import QCXFinalTextField from '../../../../../shared-components/final-text-field/QCXFinalTextField';
import QCXFinalMultilineTextField from '../../../../../shared-components/final-text-field/QCXFinalMultilineTextField';
import QCXSelectTransportadorInternacionalAutocomplete from '../../../../../shared-components/select-transportador-internacional/QCXSelectTransportadorInternacionalAutocomplete';


export default function TarifarioAereoDataForm({
  initialValues,
  handleSubmit,
  isConsult,
  isUpdate,
  controlComponentProps,
  authInfo = {},
  requiredRoles = [],
}){

  const { t } = useTranslation();

  return (
    <QCXFormStepWizard
      initialValues={initialValues}
      onSubmit={handleSubmit}
      controlComponentProps={controlComponentProps}
      authInfo={authInfo}
      requiredRoles={requiredRoles}
    >
      {({ values }) => (
        <>

          <Grid container spacing={2} style={{ marginTop: '1rem' }}>

            <Grid item xs={6} sm={6} md={6}>
              <InputWithCleanButton>
                <QCXSelectPortoAeroportoAutocomplete
                  id="select-field-local-condicao-venda"
                  key="select-field-local-condicao-venda"
                  name="destino.id"
                  label="Destino"
                  disabled={isConsult}
                  initialValues={values}
                />
              </InputWithCleanButton>
            </Grid>

            <Grid item xs={6} sm={6} md={6}>
              <InputWithCleanButton>
                <QCXSelectPortoAeroportoAutocomplete
                  id="select-field-local-condicao-venda"
                  key="select-field-local-condicao-venda"
                  name="origem.id"
                  label="Aeroporto"
                  disabled={isConsult}
                  initialValues={values}
                />
              </InputWithCleanButton>
            </Grid>


            <Grid item xs={6}>
              <QCXFinalTextField
                id="text-field-numero-transmissao"
                key="text-field-numero-transmissao"
                label="Rota"
                name="vooEstimado"
                disabled={isConsult}
              />
            </Grid>

            <Grid item xs={6} sm={6} md={6}>
              <QCXSelectTransportadorInternacionalAutocomplete
                id="autocomplete-select-agente-transportador-field"
                key="autocomplete-select-agente-transportador-field"
                name="transportadorInternacional"
                label="Cia Aérea"
                initialValues={values}
                disabled={isConsult}
                aereoOnly
              />
            </Grid>


            <Grid item xs={6} sm={6} md={6}>
              <div style={{ display: 'flex', gap: '8px' }}>
                <QCXFinalAlternativeCurrencyField
                  id="numeric-decimal-45kg-field"
                  name="tarifa45kg"
                  label="45 Kg"
                  disabled={isConsult}
                  scale={7}
                />
                <QCXFinalAlternativeCurrencyField
                  id="numeric-decimal-100kg-field"
                  name="tarifa100kg"
                  label="100 Kg"
                  disabled={isConsult}
                  scale={7}
                />
                <QCXFinalAlternativeCurrencyField
                  id="numeric-decimal-300kg-field"
                  name="tarifa300kg"
                  label="300 Kg"
                  disabled={isConsult}
                  scale={7}
                />
                <QCXFinalAlternativeCurrencyField
                  id="numeric-decimal-500kg-field"
                  name="tarifa500kg"
                  label="500 Kg"
                  disabled={isConsult}
                  scale={7}
                />
                <QCXFinalAlternativeCurrencyField
                  id="numeric-decimal-1000kg-field"
                  name="tarifa1000kg"
                  label="1000 Kg"
                  disabled={isConsult}
                  scale={7}
                />
              </div>
            </Grid>


            <Grid item xs={6} sm={6} md={6}>
              <QCXSelectMoedaAutocomplete
                id="select-field-moeda-seguro"
                key="select-field-moeda-seguro"
                name="moeda.id"
                label="Moeda"
                disabled={isConsult}
                initialValues={values}
              />
            </Grid>


            <Grid item xs={4}>
              <QCXFinalTextField
                id="text-field-numero-transmissao"
                key="text-field-numero-transmissao"
                label="Transit Time"
                name="transitTime"
                disabled={isConsult}
              />
            </Grid>

            <Grid item xs={4}>
              <QCXFinalTextField
                id="text-field-numero-transmissao"
                key="text-field-numero-transmissao"
                label="Vôo Estimado"
                name="vooEstimado"
                disabled={isConsult}
              />
            </Grid>


            <Grid item xs={4}>
              <QCXFinalDatePickerField
                id="date-picker-field-data-registro"
                key="date-picker-field-data-registro"
                label="Validade"
                name="atributosAdicionais.dataRegistroSiscomex"
                disabled={isConsult}
              />
            </Grid>

            
            <Grid item xs={12}>
              <QCXFinalMultilineTextField
                id="text-observacao-multiline-field"
                key="text-observacao-multiline-field"
                name="observacao"
                label="Observação"
                disabled={isConsult}
                rows={5}
                maxLength={256}
                remaningCharactersInfo
                helperText=""
              />
            </Grid>

          </Grid>
        </>
      )}    
    </QCXFormStepWizard>
  )
}
